import LoginMain from './LoginMain.json'
import Consultation from './Consultation.json'


export default {
  LoginMain,
  Consultation
}